import {
    OBTENER_LLAVES,
    GET_CONFIG_FORMINF,
    GET_TIPOS_INFORME,
    GET_COMPANIAS,
    GET_ESTADOS,
    GET_SITUACIONES,
    GET_CRITERIOS_FECHA,
    GET_CRITERIOS_PEND,
    GET_INFORMES_PREVIOS,
    POST_GENERAR_INFORME
} from '../types';


export default function informeAdministracionReducer(state = {}, action) {
    switch (action.type) {
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case GET_CONFIG_FORMINF:
            return { ...state, cfg_formInf: action.payload }
        case GET_TIPOS_INFORME:
            return { ...state, tiposInforme: action.payload }
        case GET_COMPANIAS:
            return { ...state, companias: action.payload }
        case GET_ESTADOS:
            return { ...state, estados: action.payload }
        case GET_SITUACIONES:
            return { ...state, situaciones: action.payload }
        case GET_CRITERIOS_FECHA:
            return { ...state, criteriosFecha: action.payload }
        case GET_CRITERIOS_PEND:
            return { ...state, criteriosPendiente: action.payload }
        case GET_INFORMES_PREVIOS:
            return { ...state, listaInformesPrevios: action.payload }
        case POST_GENERAR_INFORME:
            return { ...state, respuestaGenerar: action.payload }
        default:
            return state
    }
}